var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { updateCouponButtonPosition } from "./helpers";
import { debounce } from "debounce-decorator";
import { CouponButtonPosition } from "../../../../Typings";
var CreateCouponBtn = /** @class */ (function (_super) {
    __extends(CreateCouponBtn, _super);
    function CreateCouponBtn(props) {
        var _this = _super.call(this, props) || this;
        _this.couponBtnRef = React.createRef();
        _this.setDimensionsBound = debounce(_this.setDimensions, 10).bind(_this);
        _this.wrapperElement = window;
        _this.topOffset = 0;
        return _this;
    }
    CreateCouponBtn.prototype.setDimensions = function () {
        var parent = this.props.parentRef.current;
        var child = this.couponBtnRef.current;
        if (child && parent) {
            updateCouponButtonPosition(child, parent, this.topOffset);
        }
    };
    CreateCouponBtn.prototype.componentDidMount = function () {
        if (this.props.cuponPosition === CouponButtonPosition.Fixed) {
            this.setDimensions();
            if (this.props.deviceType.isTablet) {
                this.wrapperElement = this.props.wrapEl;
                this.topOffset = this.props.tabletTopOffSet;
            }
            this.wrapperElement.addEventListener("resize", this.setDimensionsBound);
            this.wrapperElement.addEventListener("scroll", this.setDimensionsBound);
            // "btn-is-fixed";
        }
        // "btn-is-not-fixed";
    };
    CreateCouponBtn.prototype.componentWillUnmount = function () {
        this.wrapperElement.removeEventListener("resize", this.setDimensionsBound);
        this.wrapperElement.removeEventListener("scroll", this.setDimensionsBound);
    };
    CreateCouponBtn.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "rj-league-list__coupon-btn-wrap", ref: this.couponBtnRef, "data-uat": "div-league-list-coupon" },
            React.createElement("button", { className: "rj-league-list__coupon-btn-content", onClick: function (e) { return _this.props.onClick(_this.props.sportId, e); }, "data-uat": "button-league-list-coupon" },
                this.props.label,
                " (",
                this.props.count,
                ")")));
    };
    return CreateCouponBtn;
}(React.PureComponent));
export { CreateCouponBtn };
//# sourceMappingURL=CreateCouponBtn.js.map